import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e35c724&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4e35c724&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e35c724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e35c724')) {
      api.createRecord('4e35c724', component.options)
    } else {
      api.reload('4e35c724', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e35c724&scoped=true", function () {
      api.rerender('4e35c724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pushSettings/index.vue"
export default component.exports